export { default as PilasList } from './Listar'
// export { default as TanqueCrear } from './Crear'
export { default as PilaVer } from  './Ver'

export { default as PilaSalida } from  './Salida'
